import { CURRENCY_FORMATTER } from "./constants";

export const formatRand = (n) => `R ${CURRENCY_FORMATTER.format(Number(n) || 0)}`;

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const datePart = d.toLocaleString("en-GB", { day: "2-digit", month: "short" });
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const timePart =
    minutes === 0
      ? `${hour12}${period}`
      : `${hour12}:${minutes.toString().padStart(2, "0")}${period}`;
  return `${datePart}, ${timePart}`;
};
